import { render, staticRenderFns } from "./UserActivityChart.vue?vue&type=template&id=222fc5bb&scoped=true&"
import script from "./UserActivityChart.vue?vue&type=script&lang=js&"
export * from "./UserActivityChart.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityChart.vue?vue&type=style&index=0&id=222fc5bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222fc5bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
